module.exports = __webpack_public_path__ + "img/icon.49f89b63.webp";